import { useState } from "react";

import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { Button, Text } from "@/ui/core";
import { BaseCard, Box, VStack } from "@/ui/layout";
import type { CollapsibleContainerProps } from "@/ui/layout/animated/CollapsibleContainer";
import CollapsibleContainer from "@/ui/layout/animated/CollapsibleContainer";
import { joinTestIDs } from "@/utils/string.util";

const testID = joinTestIDs("storybook", "collapsible-container");
const message = faker.lorem.paragraph();

const StoryMeta: Meta<CollapsibleContainerProps> = {
  title: "Layout/Animated/Collapsible Container",
  component: CollapsibleContainer,
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render() {
    const [isExpanded, setIsExpanded] = useState<boolean>(true);

    const handleDismiss = () => {
      setIsExpanded(false);
    };
    return (
      <Box gap={10} width="100%">
        <Box alignItems="center" flexDirection="row" justifyContent="center">
          <Button
            onPress={() => setIsExpanded(true)}
            testID={testID}
            title="Expand"
          />
        </Box>

        <CollapsibleContainer isExpanded={isExpanded} minHeight={16.5}>
          <BaseCard onPress={handleDismiss} testID="content">
            <VStack gap={20}>
              <Text testID="title">{message}</Text>
              <Text testID="message" variant="caption">
                Press card to collapse
              </Text>
            </VStack>
          </BaseCard>
        </CollapsibleContainer>
      </Box>
    );
  },
};

type Story = StoryObj<CollapsibleContainerProps>;

export default StoryMeta;
export const Primary: Story = {};
